


const PageOne = () => {
  return (
    <>
      <p className="text-xl text-foreground">You aren't born a Bro. You become one—through initiation, ritual, and public challenge.</p>
      
      <p className="text-xl text-foreground">The Cipher is your gateway.</p>
      <p className="text-xl text-foreground">The BroCode is your armor.</p>
      <p className="text-xl text-foreground">You don't wager for fiat—you stake your name, your BroScore, your TOP1.</p>
      
      <p className="text-xl font-bold text-foreground">Weakness is a phase. Brotherhood is a system.</p>
      
      <div className="flex items-center space-x-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain"
        />
        <p className="text-xl text-foreground">We are not influencers. We are initiators.</p>
      </div>
      
      <div className="flex items-center space-x-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain"
        />
        <p className="text-xl text-foreground">This is the last pump you'll ever need.</p>
      </div>
    </>
  );
};

export default PageOne;
